import { useSelector } from "react-redux";
import { RootState } from "../store/index";
import { User } from '../model/user.d';

export const useUser = (): User|null => {
  const { data } = useSelector((store: RootState) => store.user);

  return data;
}

export const useCollectionYear = (): string => {
  const { data } = useSelector((store: RootState) => store.user);

  // TODO: have a better fallback for this
  if (typeof data?.collection_year === 'undefined') {
    return '2022';
  } else {
    return data.collection_year;
  }
}
